import { render, staticRenderFns } from "./makeupRecords.vue?vue&type=template&id=b269007e&scoped=true&"
import script from "./makeupRecords.vue?vue&type=script&lang=js&"
export * from "./makeupRecords.vue?vue&type=script&lang=js&"
import style0 from "./makeupRecords.vue?vue&type=style&index=0&id=b269007e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b269007e",
  null
  
)

export default component.exports